import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroProductName = (props: PropsWithChildren) => {
  const { children } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <BodyText sizeMatch={['14']} style={styles.text}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.OPACITY.DARK_KALE.DARKER,
  },
});
